export enum InsuranceDesignationType {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Coupon = 'Coupon',
  Tertiary = 'Tertiary',
}

export enum InsurancePlanType {
  Commercial = 'Commercial',
  Government = 'Government',
  MedicarePartB = 'Medicare Part B',
  MedicarePartD = 'Medicare Part D',
  Medicaid = 'Medicaid',
  SavingsCard = 'Savings Card',
  NotSpecified = 'Not Specified',
  MedicareBridge = 'Medicare Bridge',
}

export enum InsurancePlanTypeV2 {
  Commercial = 'Commercial',
  CouponCard = 'Coupon Card',
  DiscountCard = 'Discount Card',
  Government = 'Government',
  Medicaid = 'Medicaid',
  MedicarePartB = 'Medicare Part B',
  MedicarePartD = 'Medicare Part D',
  NotSpecified = 'Not Specified',
  SavingsCard = 'Savings Card',
  WorkersComp = "Worker's Comp",
  MedicareBridge = 'Medicare Bridge',
}

// string form of FieldCodes.PatientRelationship that we are actually saving
export enum InsurancePatientRelationship {
  NotSpecified = 'NotSpecified',
  Cardholder = 'Cardholder',
  Spouse = 'Spouse',
  Child = 'Child',
  Other = 'Other',
  Student = 'Student',
  Disabled = 'Disabled',
  AdultDependent = 'AdultDependent',
  SignificantOther = 'SignificantOther',
}

export enum InsuranceCardType {
  NotSpecified = '',
  Insurance = 'insurance',
  SavingsCard = 'savings_card',
}

export interface InsuranceData {
  benefitEffectiveDate?: string
  bin: string
  cardholderId?: string
  coverageType?: string
  designation?: InsuranceDesignationType
  governmentSponsoredPlan?: boolean
  planType?: InsurancePlanTypeV2
  group?: string
  helpdeskNumber?: string
  images?: {
    front: string
    back?: string
  }
  name?: string
  pcn?: string
  personCode?: string
  relationship?: InsurancePatientRelationship
  cardType?: InsuranceCardType
  coreInsuranceToken?: string
}

export enum BinCodes {
  CASH = '025573',
}
